export default __webpack_public_path__ + "static/media/ubereats-sm-light.0ff97c23.svg";